import { DRIVING_SCHOOLS_OPTIONS, HELP_SEARCH_OPTIONS } from './constants';

const COMMON_SWITCHER_ITEMS = ['1', '2', '3', '4', '5'];

export const FORM_TEXTS = {
  title: 'Laisser un avis',
  titleNote: '* Les champs munis de ce symbole sont obligatoires',
  starsData: {
    label: 'Note globale',
  },
  registrationData: {
    label: 'Inscription',
    caption: 'Comment s’est déroulée votre inscription sur le site (nombre de sessions et de places disponibles sur ce centre, paiement, etc)?',
    items: COMMON_SWITCHER_ITEMS,
  },
  waitingRoomData: {
    label: 'Accueil et attente',
    caption: 'Évaluez l’accueil reçu sur le centre d’examen (attente devant et dans le centre, accueil par l’examinateur).',
    items: COMMON_SWITCHER_ITEMS,
  },
  examRoomData: {
    label: 'Salle d’examen',
    caption: 'Comment avez-vous trouvé les locaux et la salle d’examen (état et propreté, présence de bruits…)?',
    items: COMMON_SWITCHER_ITEMS,
  },
  equipmentData: {
    label: 'Matériel',
    caption: 'Comment jugeriez-vous le matériel mis à votre disposition pour passer l’examen (tablette, casque)?',
    items: COMMON_SWITCHER_ITEMS,
  },
  resultAvailabilityData: {
    label: 'Accès aux résultat',
    caption: 'Évaluez la transmission de votre résultat à l’examen (délai de réception du résultat, mode de transmission)?',
    items: COMMON_SWITCHER_ITEMS,
  },
  textarea: {
    label: 'Commentaire',
    rulesLink: 'Voir les critères de publication des avis',
    comment: 'Attention, les avis sont publiés et référencés, soyez courtois, ne citez pas le nom des personnes dans votre commentaire.',
  },
  examDate: {
    label: 'Date de l\'examen',
    placeholder: 'Date de passage de l\'examen',
  },
  drivingSchoolType: {
    label: 'Vous êtes inscrit(e) dans une auto-école',
    items: DRIVING_SCHOOLS_OPTIONS,
  },
  helpSearchSchool: {
    label: 'On vous aide à trouver une auto-école de qualité près de chez vous ?',
    items: HELP_SEARCH_OPTIONS,
  },
  zipcode: {
    label: 'Votre code postal',
    placeholder: '75018',
  },
  phone: {
    label: 'Numéro de téléphone portable',
    placeholder: '06 05 04 03 02',
  },
};
